import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { FiLogOut } from "react-icons/fi";
import "../styles/Sidebar.css";

export default function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <aside className="sidebar">
      <div className="logo-section">
        <img
          src="/Digital Subscriptions.png"
          alt="UnlokDigital Logo"
          className="logo-img"
        />
        <div>
          <h2>UnlokDigital</h2>
        </div>
      </div>

      <nav>
        <ul>
          <li className="active">Dashboard</li>
          <li>Envato Elements</li>
        </ul>
      </nav>

      <div className="logout-link" onClick={handleLogout}>
        <FiLogOut className="logout-icon" />
        <span>Logout</span>
      </div>
    </aside>
  );
}
